import {JsToClientCommand} from '../jsToClientCommand';
import {ClientCommands} from '../clientCommands';
import { GameStartData } from '../../types/client';


export class SetStartDataCommand extends JsToClientCommand<Partial<GameStartData>> {
    constructor(params: Partial<GameStartData>) {
        super(ClientCommands.SET_START_DATA, params);
    }
}
